import axios from 'axios'
import { API } from '../../utils/index'
const instance = axios.create()


export const getMedias = async () => {
	const _endpoint = 'media'
	const URL = `${API}/${_endpoint}`
	return instance.get(URL)
}